import { SHOWCASE_PATH } from 'cpmCarparks/navigation';

module.exports = {
  path: SHOWCASE_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/Main'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/routes/show/routes/showcase/index.js